"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixBodyUtil = void 0;
const eventList = ['touchmove', 'wheel'];
const BODY_FIXING_CLASS = 'lemon8-body-fixing';
const preventDefaultHandler = (event) => {
    event.preventDefault();
};
exports.FixBodyUtil = {
    lastScrollY: 0,
    /** will disable scrolling for all elements of the page  */
    fix: () => {
        eventList.forEach((event) => {
            document.body.addEventListener(event, preventDefaultHandler, { passive: false });
        });
    },
    restore: () => {
        eventList.forEach((event) => {
            document.body.removeEventListener(event, preventDefaultHandler);
        });
    },
    /** only fix body */
    partialFix: () => {
        if (document.body.classList.contains(BODY_FIXING_CLASS)) {
            return;
        }
        exports.FixBodyUtil.lastScrollY = window.scrollY;
        document.body.style.top = `-${exports.FixBodyUtil.lastScrollY}px`;
        document.body.classList.add(BODY_FIXING_CLASS);
    },
    partialRestore: () => {
        if (!document.body.classList.contains(BODY_FIXING_CLASS)) {
            return;
        }
        document.body.style.top = '';
        document.body.classList.remove(BODY_FIXING_CLASS);
        window.scrollTo({ top: exports.FixBodyUtil.lastScrollY });
    },
};
